import { Injectable } from "@angular/core";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { API_URL, OperationType } from "common/constants/sm-constants";
import { ImportExcelModel } from "common/models/utility-models/ImportExcel-model";
import { environment } from "src/environments/environment";

@Injectable()
export class ImportStudentExcelDataService extends DataService<ImportExcelModel> {
    constructor(protected ss: SystemService, protected http: SmApiService) {
        super(ss, API_URL.importExcelfile, http);
    }

    createInstance(): ImportExcelModel {
        return new ImportExcelModel();
    }

    override async postData(data, isFormData: boolean = true): Promise<any> {
        return await super.postData(this.convertFormData(data), isFormData);
    }

    override generateUrl(type: OperationType, paramKey: string | null = null, extraKey: string | null = null): string {
        return `${environment.apiUrl}${API_URL.importExcelfile}`;
    }
}
